<template>
  <v-sheet
    v-ripple
    :class="{ selected, disabled }"
    class="c360-selectable-item d-flex align-center"
    v-on="$listeners"
  >
    <c360-icon :icon="icon" :size="16" class="c360-selectable-item__icon" />
    <p class="mb-0">
      <slot />
    </p>
  </v-sheet>
</template>

<script>
  import Vue from 'vue';
  import { C360Icon } from '../../Icon';

  export default Vue.extend({
    name: 'C360SelectableItem',

    components: {
      C360Icon,
    },

    props: {
      /**
       * Indicates if this item in selected state.
       */
      selected: {
        type: Boolean,
        default: false,
      },

      /**
       * Indicates if this item in disabled state.
       */
      disabled: {
        type: Boolean,
        default: false,
      },

      /**
       * Item icon from the coolicons pack.
       */
      icon: {
        type: String,
        required: true,
      },
    },
  });
</script>

<style scoped>
  .c360-selectable-item {
    font-family: var(--c360-font);
    border: 1px solid var(--c360-color-light-gray);
    border-radius: 4px;
    padding: 12px 16px;
    cursor: pointer;
    font-size: 14px;
  }

  .c360-selectable-item.selected {
    color: var(--c360-color-compulse);
    border-color: var(--c360-color-compulse);
  }

  .c360-selectable-item.disabled {
    color: var(--c360-color-smooth-gray);
    border-color: var(--c360-color-smooth-gray);
  }

  .c360-selectable-item.selected .c-icon {
     color: var(--c360-color-compulse);
  }

  .c360-selectable-item.disabled .c-icon {
     color: var(--c360-color-smooth-gray);
  }

  .c360-selectable-item__icon {
    color: var(--c360-color-charcoal-gray);
    margin-right: 10px;
  }
</style>
